import {
  IonContent,
  IonText,
  IonIcon,
  IonItem,
  IonPage,
  IonButton,
  IonRow,
  IonCol,
  IonItemDivider,
  IonGrid,
  IonCard,
  IonLabel,
  IonInput,
  IonTextarea,
} from "@ionic/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Foot from "./Foot";
import { calendarNumber, call, callOutline, location, locationOutline, logoFacebook, logoInstagram, logoTwitter, logoWhatsapp, logoYoutube, mailOutline, phonePortraitOutline } from "ionicons/icons";
import UserHead from "./UserHead";
import axios from "axios";
import Authservice from "../Services/auth.service";
import "./Home.css";
import "./ContactUs.css";
import { useHistory } from "react-router";
import Head from "./Head";
import { Capacitor } from "@capacitor/core";
import HeadFoot from "./Head";

const ContactUs: React.FC = () => {
  const recipient = 'contact@atmagram.com';
  const subject = 'Atmagram';


  const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
    subject
  )}`;
  const phone = "+918281641474";

  const shareViaWhatsapp = () => {
    const phoneNumber = '+918281641474'; // Replace with the phone number you want to share with
    const message = encodeURIComponent('Hi Atmagram');

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };


  return (
    <IonPage>
      <IonContent>
        <HeadFoot User={"login"} Role={'Role'} Name='Home,Contact' />
        <div className="page_content_padding">
          <IonGrid className="content_container">
            <IonRow className="center_col">
              <IonCol size="12" sizeLg="6" >
                <IonCard className="card_container">
                  <IonRow style={{ textAlign: "center" }}>
                    <IonText className="card_head_text">
                      Contact Information
                    </IonText>
                  </IonRow>

                  <IonRow style={{ marginTop: "20px" }}>
                    <IonCol size="2">
                      <IonIcon src={callOutline} className="icon_contact" />
                    </IonCol>
                    <IonCol size="10"> <a href={`tel:${phone}`} style={{ color: "#ffffff" }}>
                      <IonText className="phone_contact">
                        +91 8281641474
                      </IonText></a>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginTop: "20px" }}>
                    <IonCol size="2">
                      <IonIcon src={mailOutline} className="icon_contact" />
                    </IonCol>
                    <IonCol size="10">
                      <IonText className="phone_contact">
                        contact@atmagram.com
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow style={{ marginTop: "20px" }}>
                    <IonCol size="2">
                      <IonIcon src={location} className="icon_contact" />
                    </IonCol>
                    <IonCol size="10">
                      <IonText className="address_contact">
                        Sri Sankara Peetam Charitable Trust
                        11/570, Thachappillil House
                        Kalady Post
                        Ernakulam 683574
                        Kerala, India
                      </IonText>
                    </IonCol>
                  </IonRow>
                  <IonRow className="media_logo_container">
                    <a className="font_icon" href="https://www.facebook.com/profile.php?id=61556576180451&mibextid=ZbWKwL" target="_blank">
                      <IonIcon src={logoFacebook} />
                    </a>

                    <a className="font_icon" href="https://www.instagram.com/srisankarapeetam?igsh=dTMwaWJlamNybjE5" target="_blank">
                      <IonIcon src={logoInstagram} />
                    </a>
                    <IonIcon onClick={shareViaWhatsapp} src={logoWhatsapp} className="font_icon" tabIndex={0} />
                    <a className="font_icon" href="https://youtube.com/@srisankarapeetam3817?si=CUV17hFUfGHGnqS5" target="_blank">
                      <IonIcon src={logoYoutube} /></a>

                    <a href={mailtoLink} target="_blank" className="font_icon" rel="noopener noreferrer" >
                      <IonIcon src={mailOutline} /></a>
                    <a href={`tel:${phone}`} >
                      <IonIcon src={callOutline} className="font_icon" tabIndex={0} /></a>
                  </IonRow>
                </IonCard>
              </IonCol>
              {/* <IonCol style={{ paddingLeft: "30px" }} size="7">
                <IonRow>
                  <IonCol size="6" style={{ paddingRight: "40px" }}>
                    <IonLabel>
                      First Name
                    </IonLabel>
                    <IonRow style={{ marginTop: "10px" }}>
                      <IonInput className="contact_input" placeholder="Enter Firstname" />
                    </IonRow>
                  </IonCol>
                  <IonCol size="6" style={{ paddingLeft: "20px" }}>
                    <IonLabel>
                      Last Name
                    </IonLabel>
                    <IonRow style={{ marginTop: "10px" }}>
                      <IonInput className="contact_input" placeholder="Enter Lastname" />
                    </IonRow>
                  </IonCol>
                </IonRow>
                <IonRow style={{ marginTop: "40px" }}>
                  <IonCol size="6" style={{ paddingRight: "40px" }}>
                    <IonLabel>
                      E-Mail
                    </IonLabel>
                    <IonRow style={{ marginTop: "10px" }}>
                      <IonInput className="contact_input" placeholder="Enter your mail-id" />
                    </IonRow>
                  </IonCol>
                  <IonCol size="6" style={{ paddingLeft: "20px" }}>
                    <IonLabel>
                      Mobile Number
                    </IonLabel>
                    <IonRow style={{ marginTop: "10px" }}>
                      <IonInput className="contact_input" placeholder="Enter mobile number" />
                    </IonRow>
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="12" style={{ marginTop: "40px" }}>
                    <IonLabel>
                      Message
                    </IonLabel>
                    <IonRow style={{ marginTop: "10px" }}>
                      <IonTextarea autoGrow className="message_contact" placeholder="Your Message" />
                    </IonRow>
                  </IonCol>
                </IonRow>
                <IonRow style={{ textAlign: "center" }}>
                  <IonCol size="12">
                    <IonButton>
                      <span className="button_padding">
                        Submit
                      </span>
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonCol> */}
            </IonRow>
          </IonGrid>
        </div>
        <Foot />
      </IonContent>
    </IonPage>
  );
};

export default ContactUs;